import React, { useEffect, useState } from "react";
import SisLoader from "../../../../widgets/loader";
import { Button } from "antd";
import { ErrorToast, SuccessToast } from "../../../../widgets/AppToast";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import AddPumpModal from "../components/AddPumpModal";
import PumpTable from "../components/PumpRow";

function Pumps({ id, onSuccess }) {
  const [loader, set_loader] = useState(false);
  const [FilteredData, setFilteredData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [responeData, setResponeData] = useState({});
  const [errors, set_errors] = useState({});

  const LIST_API = () => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("ship_id", id);
      post(ApiURL.list_pump_details_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          setFilteredData(res?.response_data);
        }
      });
    } catch (error) {
      console.error("Error fetching ship list:", error);
    } finally {
    }
  };

  useEffect(() => {
    LIST_API();
  }, []);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const ADD_API = (data) => {
    try {
      set_loader(true);
      const FORM_DATA = new FormData();
      // FORM_DATA.append("rating", rating);
      FORM_DATA.append("title", data?.title);
      FORM_DATA.append("pump_model", data?.model);
      FORM_DATA.append("pump_maker", data?.make);
      FORM_DATA.append("ship_id", id);
      FORM_DATA.append("selected_parameters", JSON.stringify(data?.selectedParams));
      FORM_DATA.append("other_parameters", JSON.stringify(data?.customParams));
      post(ApiURL.add_pump_details_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          SuccessToast("Pump Details Saved!", "Pump Details Successfully Added!!");
          setIsModalOpen(false);
          LIST_API();
          set_loader(false);
          if (onSuccess) onSuccess();
        } else {
          set_loader(false);
          const rawErrors = res?.errors || res?.response?.data?.errors || {};
          const transformedErrors = Array.isArray(rawErrors)
            ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
            : rawErrors;
          set_errors(transformedErrors);
        }
      });
    } finally {
    }
  };

  const UPDATE_API = (data) => {
    try {
      set_loader(true);
      const FORM_DATA = new FormData();
      FORM_DATA.append("title", data?.title);
      FORM_DATA.append("pump_model", data?.model);
      FORM_DATA.append("pump_maker", data?.make);
      FORM_DATA.append("ship_id", id);
      FORM_DATA.append("selected_parameters", JSON.stringify(data?.selectedParams));
      FORM_DATA.append("other_parameters", JSON.stringify(data?.customParams));
      FORM_DATA.append("id", data?.id);
      FORM_DATA.append("request_type", "add-edit");
      FORM_DATA.append("ship_id", id);
      post(ApiURL.ship_pump_details_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          SuccessToast("Congratulation!!", "Pump Details Successfully Update!!");
          set_loader(false);
          LIST_API();
          setIsModalOpen(false);
          set_loader(false);
         
        } else {
          set_loader(false);
          const rawErrors = res?.errors || res?.response?.data?.errors || {};
          const transformedErrors = Array.isArray(rawErrors)
            ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
            : rawErrors;
          set_errors(transformedErrors);
        }
      });
    } catch (error) {
      set_loader(false);
      ErrorToast("Error Occurred", "There was an error during registration.");
    }
  };

  const VIEW_API = (data) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("ship_id", id);
      FORM_DATA.append("id", data?.id);
      FORM_DATA.append("request_type", "view");
      post(ApiURL.ship_pump_details_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          setResponeData(res?.pump_data);
          setIsModalOpen(true);
        } else {
          const rawErrors = res?.errors || res?.response?.data?.errors || {};
          const transformedErrors = Array.isArray(rawErrors)
            ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
            : rawErrors;
          set_errors(transformedErrors);
          set_loader(false);
        }
      });
    } finally {
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div style={{ position: "relative" }}>
        <h3 style={{ marginTop: "15px", marginBottom: "15px" }}>Pump Information </h3>
        <Button
          type="primary"
          onClick={showModal}
          style={{ position: "absolute", right: "0px", top: "-10px" }}
        >
          Add Pump
        </Button>
        <AddPumpModal
          visible={isModalOpen}
          onOk={(data) => {
            if (responeData?.id) {
              UPDATE_API({ ...data, id: responeData.id });
            } else {
              ADD_API(data);
            }
          }}
          onCancel={() => {
            setIsModalOpen(false);
            setResponeData({});
            set_errors({});
          }}
          responeData={responeData}
          errors={errors}
        />
        {loader ? (
          <SisLoader />
        ) : (
          <>
            {FilteredData?.length > 0 ? (
              <>
                {/* {FilteredData?.map((item) => ( */}
                <>
                  <PumpTable ship_id={id} data={FilteredData} onEdit={(row) => VIEW_API(row)} />
                </>
                {/* ))} */}
              </>
            ) : (
              "No data available"
            )}
          </>
        )}
      </div>
    </>
  );
}

export default Pumps;
